import React from 'react'
import { formatMoney, formatPct, ExpenseAnomalyMonthCell } from '../types'

type Props = {
  cell?: ExpenseAnomalyMonthCell | null
  onClick?: () => void
  clickable?: boolean
}

const MonthlyCell: React.FC<Props> = ({ cell, onClick, clickable }) => {
  if (!cell) {
    return <span className='text-muted'>—</span>
  }

  const anomaly = !!cell.isAnomaly
  const pct = formatPct(cell.variancePercentage)
  const content = (
    <>
      <div className='ss-anomaly-cell__amount'>{formatMoney(cell.amount)}</div>
      {anomaly && pct ? (
        <div className='ss-anomaly-cell__delta'>
          <span className='ss-anomaly-cell__arrow' aria-hidden='true'>
            ↑
          </span>{' '}
          {pct.replace('+', '')}
        </div>
      ) : null}
    </>
  )

  if (anomaly) {
    return (
      <button
        type='button'
        className={`ss-anomaly-cell ss-anomaly-cell--hit ${clickable ? 'ss-anomaly-cell--clickable' : ''}`}
        onClick={clickable ? onClick : undefined}
        title={cell.explanation || undefined}
        disabled={!clickable}
      >
        {content}
      </button>
    )
  }

  return <div className='ss-anomaly-cell ss-anomaly-cell--normal'>{content}</div>
}

export default MonthlyCell
